import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { sizes, getTypeValues } from '../types'

import FormGroup from './FormGroup'

const propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(getTypeValues(sizes)),
  id: PropTypes.string,
  isFormGroup: PropTypes.bool,
  formGroupStyle: PropTypes.object,
  addOnLeft: PropTypes.node,
  addOnRight: PropTypes.node,
  value: PropTypes.string,
  error: PropTypes.string,
  inputStyle: PropTypes.object,
  className: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.node
  })
}

const defaultProps = {
  type: 'text',
  isFormGroup: true
}

const InputGroup = (props) => {
  const {
    type,
    placeholder,
    size,
    id,
    isFormGroup,
    formGroupStyle, // eslint-disable-line no-unused-vars
    addOnLeft,
    addOnRight,
    value,
    inputStyle,
    className,
    input: inputProps,
    meta: { touched, error },
    ...otherProps
  } = props

  const showError = touched && error

  const componentClass = cx(
    'form-control',
    'input',
    {
      [`form-control-${size}`]: size,
      [`input-${size}`]: size,
      'error': showError
    },
    className
  )

  const inputGroup = (
    <div>
      <div className={cx('input-group')}>
        {addOnLeft}
        <input
          type={type}
          className={componentClass}
          id={id}
          value={value || ''}
          style={inputStyle}
          placeholder={placeholder}
          {...inputProps}
          {...otherProps}
        />
        {addOnRight}
      </div>
      {showError &&
        <div className={cx('form-error-message')}>{error}</div>
      }
    </div>
  )

  if (isFormGroup) {
    return (
      <FormGroup {...props} >
        {inputGroup}
      </FormGroup>
    )
  }

  return inputGroup
}

InputGroup.propTypes = propTypes
InputGroup.defaultProps = defaultProps

export default InputGroup
